var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-main',[_c('v-container',{staticClass:"fill-height",attrs:{"fluid":""}},[_c('v-row',{attrs:{"align":"center","justify":"center"}},[_c('v-col',{attrs:{"cols":"1"}},[_c('v-progress-circular',{attrs:{"color":"primary","indeterminate":""}})],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }